import GlobalSearch from '@/components/molecules/globalSearch';
import React, { useEffect, useMemo, useState } from 'react';
import SearchBox from './SearchBox';

export default function Search({
	prefillValue = '',
	type = 'brokers',
	placeholder = 'Search',
	onClick,
	onChange,
	handleClearSearch,
	disabled,
	className,
	inputClassName,
	searchIconClassName,
	closeIconClassName,
	searchBoxReset = false,
}) {
	const [query, setQuery] = useState('');
	const [suggestions, setSuggestions] = useState([]);
	const [clearSearch, setClearSearch] = useState(false);

	useEffect(() => {
		const fetchSuggestions = async (usePrefill) => {
			try {
				let opts = {};
				if (usePrefill) {
					opts.id = prefillValue;
				} else {
					opts.query = query;
				}
				const response = await axios.get(route(`admin.${type}.search`, opts));
				setSuggestions(response.data);
			} catch (error) {
				console.error('Error fetching suggestions:', error);
			}
		};

		if (query.length > 0) {
			fetchSuggestions();
		} else if (prefillValue !== '' && !clearSearch) {
			fetchSuggestions(true);
		} else {
			// Clear suggestions if the query is empty
			setSuggestions([]);
			if (clearSearch) {
				setClearSearch(false);
			}
		}
	}, [prefillValue, query, type]);

	const selectedValue = useMemo(() => {
		if (prefillValue !== '') {
			return suggestions.find((item) => parseInt(item?.id) === parseInt(prefillValue))?.name;
		}
		return null;
	}, [prefillValue, JSON.stringify(suggestions)]);

	useEffect(() => {
		if (!!query?.length && searchBoxReset) {
			setClearSearch(true);
			setQuery('');
		}
	}, [prefillValue, searchBoxReset]);

	return (
		<SearchBox
			type={type}
			placeholder={placeholder}
			query={query}
			selectedValue={selectedValue}
			onChange={(e) => {
				setQuery(e.target.value);
				!!onChange && onChange(e.target.value);
			}}
			onClick={(e, val) => {
				e.preventDefault();
				onClick(val);
			}}
			handleClearSearch={() => {
				setQuery('');
				setClearSearch(true);
				handleClearSearch && handleClearSearch();
			}}
			results={suggestions}
			disabled={disabled}
			className={className}
			inputClassName={inputClassName}
			searchIconClassName={searchIconClassName}
			closeIconClassName={closeIconClassName}
		/>
	);
}
